module.exports = __webpack_public_path__ + "img/ux.c2d69896.png";